import * as React from 'react';
export const almaSvg = React.forwardRef(function almaSvgInner(props, ref) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      d: 'M11.155 4.373C10.5 1.843 9.109 1 7.8 1c-1.31 0-2.7.843-3.355 3.373L1.5 15h2.864c.49-1.771 1.881-2.783 3.436-2.783s2.946 1.012 3.436 2.783H14.1L11.155 4.373ZM7.8 9.771c-.9 0-1.718.337-2.29.928l1.635-6.241c.164-.59.41-.76.737-.76s.573.17.736.76l1.636 6.24c-.736-.59-1.554-.927-2.454-.927Z',
    }),
  );
});
almaSvg.defaultProps = {
  width: '16',
  height: '16',
  viewBox: '0 0 16 16',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var alma = {
  category: 'paymentmethod',
  colorable: true,
  name: 'alma',
  svg: almaSvg,
};
